import RequestService from './request';

export interface GrafanaResponse {
    enabled: boolean;
    dashboard_url?: string;
}

export class GrafanaService {
    show(): Promise<GrafanaResponse> {
        return RequestService.post('/servers/:server/grafana');
    }
}

export default new GrafanaService();
